module.exports = __webpack_public_path__ + "img/logo_brand.3af7e0fd.png";